import React from 'react';
export function FooterSection() {
  return <footer className="border-t border-white/10 bg-carbon py-10" data-id="element-47" data-mp="21gp4me2bnvm0">
      <div className="mx-auto max-w-[1080px] px-5 text-center" data-id="element-48" data-mp="337y8f6uy12rg">
        <p className="font-display text-[13px] font-semibold tracking-[0.22em] text-ink-light" data-id="element-49" data-mp="3h8iqg0t1aujw">
          NEROVIX
        </p>
        <nav aria-label="Enlaces legales" className="mt-4 flex items-center justify-center gap-4 text-[11px] font-medium text-ink-light/60" data-id="element-50" data-mp="3c9fwpcii8ar8">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-51" data-mp="2kii2g40hoi3n">
            Términos
          </a>
          <span aria-hidden="true" className="text-ink-light/25" data-id="element-52" data-mp="2yb7scjj52761">
            ·
          </span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-53" data-mp="2thn0784887er">
            Privacidad
          </a>
          <span aria-hidden="true" className="text-ink-light/25" data-id="element-54" data-mp="20vaqecutjosq">
            ·
          </span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-55" data-mp="1ghhu55mt3mok">
            Contacto
          </a>
        </nav>
        <p className="mt-5 text-[10px] font-medium text-ink-light/40" data-id="element-56" data-mp="1q6j6mlu57lxs">
          © 2026 Nerovix. Todos los derechos reservados.
        </p>
        <p className="mx-auto mt-3 max-w-[460px] text-[10px] font-medium leading-relaxed text-ink-light/30" data-id="element-57" data-mp="1v4krncb4pvbw">
          Este producto contiene material educativo y no garantiza resultados
          específicos. Los resultados dependen de cada persona, situación y
          aplicación del contenido.
        </p>
      </div>
    </footer>;
}